import { AxiosRequestConfig } from "axios";
import services from "../services";

const HARDCODED_TOKEN = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9..."; // Token truncado para brevedad
const BASE_URL = process.env.REACT_APP_API_URL || "/";

export const getConfig = async () => {
  const token = localStorage.getItem("token");

  const config = {
    baseURL: BASE_URL,
    headers: {}
  };

  if (process.env.REACT_APP_ENVIRONMENT === "dev") {
    config.headers["X-Token"] = HARDCODED_TOKEN;
  }

  if (token) {
    config.headers["X-Token"] = token;
  }

  return config;
};

export const handleRequest = async (
  requestFunction: (
    url: string,
    body?: any,
    config?: AxiosRequestConfig
  ) => Promise<any>,
  url: string,
  config: AxiosRequestConfig,
  body?: any
) => {
  const defaultConfig = await getConfig();
  try {
    let response;
    if (body) {
      response = await requestFunction(url, body, {
        ...defaultConfig,
        ...config,
      });
    } else {
      response = await requestFunction(url, {
        ...defaultConfig,
        ...config,
      });
    }
    return response.data;
  } catch (error: any) {
    if (error.response && error.response.status === 401) {
      services.auth.signOut(process.env.REACT_APP_MCA_URL);
      throw new Error("Token expired");
    }
    throw error;
  }
};
